<template>
  <div>
    <div class="printBtnBox">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <div class="printContent">
      <div id="print" :contentLoading="contentLoading">
        <div class="printContainer">
          <!-- 打印标签区域 - 每个数据项生成多行相同的标签 -->
          <div v-for="(form,index) in productionOrderList" :key="index" class="dataList" style="margin-bottom: 20px; width: 100%;">
            <div class="qrCodeBox">
              <svg :id="'qrCode'+form.orders"/>
              <div style="flex: 1;">
                <div class="title">新时达工控技术(杭州)有限公司</div>
                <div class="title smallTitle">{{printType === 1 ? '生产工单' : printType === 3 ? '缺料打印' : '生产领料单'}}</div>
              </div>
            </div>
            <el-descriptions border :column="3" :label-style="{'word-break': 'keep-all'}">
              <el-descriptions-item label="生产工单号">{{form.orders}}</el-descriptions-item>
              <el-descriptions-item label="创建日期">{{form.addDate}}</el-descriptions-item>
              <el-descriptions-item label="工单类型">{{form.orderTypeName}}</el-descriptions-item>
              <el-descriptions-item label="规格型号">{{form.specification}}</el-descriptions-item>
              <el-descriptions-item label="物料编号">{{form.materialNo}}</el-descriptions-item>
              <el-descriptions-item label="物料描述">{{form.materialDescription}}</el-descriptions-item>
              <el-descriptions-item label="工单数量">{{form.orderNum}}</el-descriptions-item>
              <el-descriptions-item label="计划开工时间">{{form.productStart}}</el-descriptions-item>
              <el-descriptions-item label="计划完工时间">{{form.productEnd}}</el-descriptions-item>
              <el-descriptions-item label="客户编号">{{form.sapCustomerNo}}</el-descriptions-item>
              <el-descriptions-item label="客户名称">{{form.customerName}}</el-descriptions-item>
              <el-descriptions-item label="销售凭证">{{form.sapSalesOrderNo}}</el-descriptions-item>
              <el-descriptions-item label="订单优先级">
                <span v-if="form.orderPriority === 'B'">正常</span>
                <span v-if="form.orderPriority === 'A'">紧急</span>
              </el-descriptions-item>
              <el-descriptions-item label="备注">{{form.orderNote}}</el-descriptions-item>
              <!--              <el-descriptions-item label="工单备注">{{form.sapNote}}</el-descriptions-item>-->
            </el-descriptions>
        
            <!-- 使用原生table标签替换el-table -->
            <table
                class="print-table"
                width="100%"
                border="1"
                cellspacing="0"
                cellpadding="5">
              <thead>
                <tr>
                  <th width="40" style="text-align: center;" class="checkbox-col">
                    <input type="checkbox" :checked="isAllSelected(form.orders)" @change="toggleAllSelection(form.orders)">
                  </th>
                  <th width="50" style="text-align: center;">序号</th>
                  <th width="120" style="text-align: center;">物料编号</th>
                  <th width="102" style="text-align: center;">旧料号</th>
                  <th width="180" style="text-align: center;" class="material-name-col">物料名称</th>
                  <th width="130" style="text-align: center;">规格型号</th>
                  <th width="80" style="text-align: center;">仓位</th>
                  <th width="110" style="text-align: center;">小仓位</th>
                  <th width="60" style="text-align: center;">库存</th>
                  <th width="90" style="text-align: center;">需求数量</th>
                  <th width="40" style="text-align: center;">单位</th>
                  <th width="60" style="text-align: center;">备注</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in form.details" :key="idx" :class="{ 'hide-in-print': printing && !isSelected(form.orders, idx) }">
                  <td style="text-align: center;" class="checkbox-col">
                    <input type="checkbox" :checked="isSelected(form.orders, idx)" @change="toggleSelection(form.orders, idx)">
                  </td>
                  <td style="text-align: center;">{{idx + 1}}</td>
                  <td style="text-align: center;">{{item.materialCode}}</td>
                  <td style="text-align: center;">{{item.mappingMaterialNo}}</td>
                  <td style="text-align: left;" class="material-name-col">{{item.materialDescription}}</td>
                  <td style="text-align: center;">{{item.specification}}</td>
                  <td style="text-align: center;">{{constant.locationNo[item.positionNo]}}</td>
                  <td style="text-align: center;">{{item.locationNo}}</td>
                  <td style="text-align: center;">{{item.locationNumber}}</td>
                  <td v-if="printType === 3" style="text-align: center;">
                    <span class="display-value">{{item.thisPostNum}}</span>
                    <input v-model="item.thisPostNum" placeholder="请输入" class="editable-input">
                  </td>
                  <td v-else style="text-align: center;">{{item.requirementNum}}</td>
                  <td style="text-align: center;">{{item.unit}}</td>
                  <td style="text-align: left;">{{item.note}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  import barCode from "jsbarcode";
  import constant from "@/util/constant";
  export default {
    data() {
      return {
        ids: [],
        contentLoading: false,
        constant,
        productionOrderList: [],
        printType: 1,
        printPkid: "",
        selectedDetails: {},
        printing: false,
      };
    },

    mounted() {
      this.printType = Number(this.$route.query.printType);
      this.printPkid = JSON.parse(this.$route.query.ids);
      if (this.printType === 3) {
        this.getDataByOrders(this.printPkid);
      } else {
        this.getData(this.printPkid);
      }
    },

    methods: {
      getData(ids) {
        this.productionOrderList = [];
        this.$http.put("basic", "sapProductionOrders/getByIds", ids).then((resp) => {
          this.productionOrderList = resp.data;
          this.initSelection();
          this.$nextTick(() => {
            this.productionOrderList.forEach(resp => {
              document.getElementById("qrCode" + resp.orders).innerHTML = "";
              this.bindQRCode(resp);
            });
          });
        });
      },
      getDataByOrders(ids) {
        this.productionOrderList = [];
        const orders = Array.isArray(ids) ? ids.join(",") : ids;
        this.$http.get("basic", `sapProductionOrders/selectPost/${orders}`).then((resp) => {
          this.productionOrderList = [resp.data];
          this.productionOrderList[0].details.forEach((item) => {
            item.thisPostNum = item.requirementNum - item.postNum;
          });
          this.initSelection();
          this.$nextTick(() => {
            this.productionOrderList.forEach(resp => {
              document.getElementById("qrCode" + resp.orders).innerHTML = "";
              this.bindQRCode(resp);
            });
          });
        });
      },
      formatDateTime(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      
      bindQRCode(row) {
        let text = row.orders;
        new barCode(
          "#qrCode" + text, text,
          {
            displayValue: true, // 是否在条形码下方显示文字
            format: "CODE128",
            height: 40,
          },
        );
      },
      initSelection() {
        this.selectedDetails = {};
        this.productionOrderList.forEach(order => {
          this.$set(this.selectedDetails, order.orders, order.details.map((_, idx) => idx));
        });
      },
      isSelected(orderId, idx) {
        return this.selectedDetails[orderId] && this.selectedDetails[orderId].includes(idx) ? true : false;
      },
      isAllSelected(orderId) {
        const order = this.productionOrderList.find(o => o.orders === orderId);
        if (!order || !order.details.length) return false;
        const selected = this.selectedDetails[orderId] || [];
        return selected.length === order.details.length;
      },
      toggleSelection(orderId, idx) {
        if (!this.selectedDetails[orderId]) {
          this.$set(this.selectedDetails, orderId, []);
        }
        const index = this.selectedDetails[orderId].indexOf(idx);
        if (index > -1) {
          this.selectedDetails[orderId].splice(index, 1);
        } else {
          this.selectedDetails[orderId].push(idx);
        }
      },
      toggleAllSelection(orderId) {
        const order = this.productionOrderList.find(o => o.orders === orderId);
        if (!order) return;
        const isAll = this.isAllSelected(orderId);
        if (isAll) {
          this.$set(this.selectedDetails, orderId, []);
        } else {
          this.$set(this.selectedDetails, orderId, order.details.map((_, idx) => idx));
        }
      },
      getPrintData() {
        return this.productionOrderList.map(order => {
          const selectedIndices = this.selectedDetails[order.orders] || [];
          const selectedDetails = selectedIndices.map(idx => order.details[idx]);
          return {
            ...order,
            details: selectedDetails,
          };
        });
      },
      printHandle() {
        this.printing = true;
        this.$nextTick(() => {
          window.print();
          this.printing = false;
          if ([2,3].includes(this.printType)) {
            this.$http
              .put("basic", "sapProductionOrders", {pkId: this.printPkid[0], wareHousePrint: true, wareHousePrintDate: this.formatDateTime(new Date())})
              .finally(() => {
                window.close();
              });
          } else {
            window.close();
          }
        });
        return false;
      },
    },
  };
  </script>

  <style lang="scss" scoped>
    .printBtnBox {
      width: 195mm; margin: 0 auto; padding: 2mm 0; position: fixed; top: 0; left: -10cm; margin-left: 50%;background-color: #fff;z-index: 999;
    }
    .printContainer {
      width: 195mm;
      margin: 10px auto;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
    
    .qrCodeBox {
      border: 1px solid #000;
      display: flex;
      align-items: center;
    }

    .title {
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-weight: 700;
      font-size: 16pt;
      color: #000;
      border-bottom: 1px solid #000;
    }

    .smallTitle {
      font-size: 14pt;
      border-bottom: none;
    }

    /* 表格样式设置 */
    .print-table {
      width: 100%;
      font-size: 9pt;
      font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif;
      color: #000;
      border-collapse: collapse;
      border: 1px solid #000;
      line-height: 1.2;
    }

    .print-table th,
    .print-table td {
      font-size: 10pt;
      color: #000;
      border: 1px solid #000;
      padding: 2px;
      word-wrap: break-word;
      word-break: break-all;
    }

    .print-table th {
      background-color: #f5f5f5;
      font-weight: bold;
      text-align: center;
      vertical-align: middle;
    }

    /* 物料名称列自动换行 */
    .material-name-col {
      width: 120px;
      max-width: 120px;
      min-width: 120px;
      word-wrap: break-word;
      word-break: break-all;
    }

        
    /* 修复el-descriptions在打印时的显示 */
    ::v-deep .el-descriptions--mini{
      font-size: 10pt;
      font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
      font-weight: normal; // 确保字体粗细适中
      color: #000; // 确保黑色打印
      border-color: #000;
    }
    ::v-deep .el-descriptions-item__label.is-bordered-label{
      font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
      font-weight: normal; // 确保字体粗细适中
      color: #000; // 确保黑色打印
      border-color: #000;
    }
    ::v-deep .el-descriptions__body{
      font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
      font-weight: normal; // 确保字体粗细适中
      color: #000; // 确保黑色打印
      border-color: #000;
    }
    ::v-deep .el-descriptions--mini.is-bordered .el-descriptions-item__cell{
      padding: 2px;
      border-color: #000;
      line-height: 1.2;
    }
    ::v-deep .el-descriptions .is-bordered .el-descriptions-item__cell{
      border-color: #000;
    }
    ::v-deep .el-descriptions-item__content{
      min-width: 100px;
    }
    .printContent{
      width: 195mm; margin: 2mm auto; padding-top: 50px;
    }
    .hide-in-print {
      display: none !important;
    }
    .editable-input{
      width: 70px;
    }
    /* 隐藏显示标签 */
  .display-value {
    display: none;
  }
    @media print {
    /* 隐藏显示标签 */
    .display-value {
      display: initial !important;
    }
    .editable-input{
      display: none !important;
    }
      ::v-deep html, ::v-deep body {
        height: auto !important;
        min-height: auto !important;
        overflow: visible !important;
        margin: 0  auto!important;
        padding: 0 !important;
      }
      ::v-deep #app {
        height: auto !important;
        min-height: auto !important;
        overflow: visible !important;
      }
      .printContainer {
        width: 195mm;
        margin: 0 auto;
      }
      .dataList {
        page-break-inside: avoid;
      }
      .dataList:not(:last-child) {
        page-break-after: always;
      }
      .printBtnBox{
        display: none;
      }
      .printContent {
        padding-top: 0;
        margin: 0 auto;
        width: 195mm;
        text-align: center;
      }
      .checkbox-col {
        display: none;
      }
    }
  </style>